module.exports = __webpack_public_path__ + "static/media/013.b7b991fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/013.jpg
// module id = 557
// module chunks = 0